import {imageMap} from "../../images/imageMap.ts";

export default function TDC5GQualitySectionComponent() {
    return (
        <section className="mbb-hiper-quality">
            <div className="content content--narrow">
                <img src={imageMap.home.hiper_kvalitet_stamp} alt="Endelig. Nu kan du få 5G-internet i Hiper-kvalitet!"/>
                <div className="text">
                    <h2 className="heading heading--montserrat heading--big heading--left">
                        <span className="large">Endelig.</span><br/>
                        5G-internet i <span className="hiper-text-stroke">Hiper-kvalitet</span>.
                    </h2>
                    <p>
                        Vi går efter at levere det bedste 5G mobile bredbånd til den billigste pris.
                        Hurtigt, stabilt og nemt at opsætte.
                        Og så endda med fri data.
                    </p>
                </div>
            </div>
        </section>
    )
}
